import Config from 'config/js/lib/config.js';

import Q from 'q';
import $ from 'jquery';


module.exports = new Config(function () {
	return Q.Promise(function (resolve, reject) {
		$(function () {
			try {
				resolve(JSON.parse($('#cms-data-environment').html()));
			} catch (e) {
				reject(e);
			}
		});
	});
});